'use client';

import React from 'react';
import Markdown from 'react-markdown';

import { classNames } from '@bytel/product-wall/helpers';
import {
    Alert,
    Align,
    IconName,
    Justify,
    Popover,
    PopoverDirection,
    Sticker,
    Text,
    TextLevels,
    TypographyAlign,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

export type PromoBannerProps = {
    sticker?: {
        value: string;
        tooltip?: string;
        color?: string;
    };
    text: string;
    isInverted: boolean;
    linkTracking?: string;
};

export function PromoBanner({ sticker, text, isInverted, linkTracking }: Readonly<PromoBannerProps>) {
    return (
        <Alert
            banner
            className={classNames('alert-iconless', isInverted ? 'has-background-main' : 'has-background-main-fade')}
            title={
                <View flexable justify={Justify.CENTER} align={Align.CENTER} className='is-flex-col-mobile gap-medium'>
                    {sticker &&
                        (sticker.tooltip ? (
                            <Popover
                                trigger={
                                    <Sticker
                                        small
                                        className={sticker.color}
                                        iconName={IconName.INFOS_CIRCLE}
                                        label={sticker.value}
                                    />
                                }
                                direction={PopoverDirection.BOTTOM}
                            >
                                {sticker.tooltip}
                            </Popover>
                        ) : (
                            <Sticker
                                small
                                label={sticker.value}
                                className={classNames('is-marginless', sticker.color ?? '')}
                            />
                        ))}
                    <Text
                        level={TextLevels.ONE}
                        marginless
                        typo={[TypographyBold.TEXT_WEIGHT_SEMIBOLD, TypographyAlign.TEXT_CENTERED]}
                        inverted={isInverted}
                    >
                        <Markdown
                            components={{
                                p: 'span',
                                a: (props) => (
                                    <a
                                        className={classNames('link', isInverted ? 'is-inverted' : '')}
                                        data-tc-clic-imp={linkTracking}
                                        {...props}
                                    />
                                ),
                            }}
                        >
                            {text}
                        </Markdown>
                    </Text>
                </View>
            }
        />
    );
}
